/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { LuDownload, LuGrip } from 'react-icons/lu'

export interface ListControlsProps {
  /** Omit on pages without a map, or in layouts without one. */
  limitToMap?: { isOn: boolean; onToggle: () => void }
  onDownload: () => void
  /** Omit on pages without a column chooser. */
  onConfigure?: () => void
  /** Nothing to act on yet, e.g. no company chosen. */
  disabled?: boolean
}

/**
 * Limit to map, export and column chooser for a list page, at the start of its toolbar's second
 * row (the toolbar wraps them to the line just above the list when space runs short).
 */
export const ListControls = ({ limitToMap, onDownload, onConfigure, disabled = false }: ListControlsProps) => {
  const iconButton = `btn btn-ghost btn-sm p-1 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer text-primary'}`
  return (
    <div className="flex items-center gap-2 shrink-0">
      {limitToMap && (
        <button
          onClick={limitToMap.onToggle}
          className={`btn btn-sm shrink-0 ${limitToMap.isOn ? 'btn-primary' : 'btn-ghost border border-base-300'}`}
          title={limitToMap.isOn ? 'Showing only items in the map viewport' : 'Showing everything that matches'}
        >
          Limit to map
        </button>
      )}

      <button className={iconButton} disabled={disabled} onClick={onDownload} title="Export to Excel">
        <LuDownload className="text-xl" />
      </button>

      {onConfigure && (
        <button className={iconButton} disabled={disabled} onClick={onConfigure} title="Customize Columns">
          <LuGrip className="text-xl" />
        </button>
      )}
    </div>
  )
}
